import * as React from "react";

const IconHeaderCaretSmallUp: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="currentColor"><polygon fill="currentColor" points="18.749 4.498 19.078 4.162 22.171 1.007 22.5 .671 21.843 .002 21.514 .338 18.749 3.16 15.984 .336 15.655 0 15 .671 15.329 1.007 18.42 4.164 18.749 4.5" transform="matrix(1 0 0 -1 -14.287 5.21)"/></svg>;
};

export default React.memo(IconHeaderCaretSmallUp);
